import { createFileRoute } from "@tanstack/react-router";

import { routeHead } from "@/lib/seo-head";
import DecorationInterieureLyon from "@/pages/DecorationInterieureLyon";

export const Route = createFileRoute("/decoration-interieure-lyon")({
  head: () =>
    routeHead({
      path: '/decoration-interieure-lyon',
      title: 'Décoration intérieure Lyon & Ouest Lyonnais | JIIA Studio',
      description: "Décoratrice d'intérieur à Lyon : conseil couleurs, sélection mobilier, planches d'ambiance et coaching déco avec JIIA Studio.",
    }),
  component: DecorationInterieureLyon,
});
